import { $http } from '@/js/http'

export default {
  // 获取用户信息
  async getUserInfo({ commit }) {
    // let user = {
    //   "email": "yangzhenzhen@youmi.net",
    //   "is_superuser": 1,
    //   "name": "\u6768\u796f\u796f",
    //   "roles": [
    //       1
    //   ],
    //   "id": 85684
    // }
    let { user } = await $http.get('/api/users/get-info/')
    commit('USER_INFO', user)
  },

  async getPermission({ commit }) {
    // let response =  {
    //   "data": {
    //       "payment": {
    //           "can_view_statement": 1,
    //           "can_payment_detail": 1,
    //           "can_interior_draw": 1,
    //           "can_send_statement": 1,
    //           "can_export_aso_finance": 1,
    //           "can_aduit_list": 1,
    //           "can_edit_statement": 1,
    //           "can_payment_pending_list": 1,
    //           "can_aduit_detail": 1,
    //           "can_import_aso_finance": 1,
    //           "can_view_aso_finance": 1,
    //           "can_edit_aso_finance": 1,
    //           "can_create_aso_finance": 1,
    //           "can_payment_unapprove_list": 1
    //       },
    //       "pushgo": {
    //           "can_view_sites": 1,
    //           "can_view_push_user": 1
    //       },
    //       "sdk": {
    //           "can_view_user_list": 1,
    //           "can_view_task_list": 1
    //       },
    //       "setting": {
    //           "can_resource": 1,
    //           "can_push_traffic": 1,
    //           "can_view_rules": 1,
    //           "can_channel_fake_id": 1,
    //           "can_edit_rule_status": 1,
    //           "can_edit_rules": 1,
    //           "can_create_rules": 1,
    //           "can_offer_access": 1,
    //           "can_smartlink_creative": 1,
    //           "can_carrier_list": 1,
    //           "can_kpi_setting": 1
    //       },
    //       "feedback": {
    //           "can_view_feedback": 1
    //       },
    //       "traffic_quality": {
    //           "can_export_or_sendemail": 1,
    //           "can_feedback": 1,
    //           "can_chn_list": 1,
    //           "can_create_deduction": 1,
    //           "can_blist": 1,
    //           "can_view_deduct_notification_list": 1,
    //           "can_final_deduction": 1,
    //           "can_view_list": 1,
    //           "can_audit_deduction": 1,
    //           "can_edit_deduction": 1
    //       },
    //       "offer_detect": {
    //           "can_edit_trail_account": 1
    //       },
    //       "offer": {
    //           "can_offer_detect": 1,
    //           "can_top_offer_monitor": 1,
    //           "can_pending_view_list": 1,
    //           "can_import_offers": 1,
    //           "can_view_setting": 1,
    //           "can_view_task_list": 1,
    //           "can_edit_reject_detail": 1,
    //           "can_offer_recommend": 1,
    //           "can_edit_api_offer": 1,
    //           "can_cr_control": 1,
    //           "can_create_aso_offer": 1,
    //           "can_edit_detail": 1,
    //           "can_application_apply": 1,
    //           "can_view_log": 1,
    //           "can_offer_param": 1,
    //           "can_change_status": 1,
    //           "can_edit_pending_detail": 1,
    //           "can_export_offer": 1,
    //           "can_sml_setting": 1,
    //           "can_js_top_offer_control": 1,
    //           "can_offer_package": 1,
    //           "can_lock_offer_level": 1,
    //           "can_view_api_offer": 1,
    //           "can_copy_api_offer": 1,
    //           "can_manage_setting": 1,
    //           "can_edit_sml": 1,
    //           "can_view_list": 1,
    //           "can_edit_aso_offer": 1,
    //           "can_view_detail": 1,
    //           "can_create_sml": 1,
    //           "can_view_offer_control": 1,
    //           "can_application_view": 1,
    //           "can_offer_match": 1,
    //           "can_view_aso_offer": 1,
    //           "can_copy_offer": 1,
    //           "can_view_sml": 1,
    //           "can_create_offer": 1,
    //           "can_top_offer_control": 1,
    //           "can_manage_track_link": 1
    //       },
    //       "online_earning": {
    //           "can_view_news": 1
    //       },
    //       "support": {
    //           "can_view_support": 1
    //       },
    //       "report": {
    //           "can_order_information": 1,
    //           "can_cpi_ader_leader": 1,
    //           "can_aff_manage": 1,
    //           "can_new_emp": 1,
    //           "can_otc_detail_data": 1,
    //           "can_global_manage": 1,
    //           "can_ader_manage_new_emp": 1,
    //           "can_ssp_ader_leader": 1,
    //           "can_ader_manage": 1,
    //           "can_cp_subscription": 1,
    //           "can_only_invalid_click_report": 1,
    //           "can_cpa_ader_leader": 1
    //       },
    //       "ader": {
    //           "can_change_admin": 1,
    //           "can_view_setting": 1,
    //           "can_view_detail": 1,
    //           "can_change_template_setting": 1,
    //           "can_view_domain_statistics": 1,
    //           "can_view_of_test": 1,
    //           "can_change_sale": 1,
    //           "can_ader_export": 1,
    //           "can_create_ader": 1,
    //           "can_view_template_setting": 1,
    //           "can_edit_detail": 1,
    //           "can_view_list": 1,
    //           "can_view_log": 1,
    //           "can_change_status": 1,
    //           "can_view_domain_management": 1,
    //           "can_change_pull_setting": 1,
    //           "can_change_password": 1,
    //           "can_login_user": 1,
    //           "can_manage_ip_track_link": 1,
    //           "can_manage_setting": 1,
    //           "can_view_pull_setting": 1,
    //           "can_manage_of_test": 1
    //       },
    //       "aff": {
    //           "can_change_admin": 1,
    //           "can_approval_account": 1,
    //           "can_view_setting": 1,
    //           "can_manage_notify": 1,
    //           "can_view_list": 1,
    //           "can_view_pending": 1,
    //           "can_view_log": 1,
    //           "can_sml_setting": 1,
    //           "can_view_channel": 1,
    //           "can_approve_pending": 1,
    //           "can_manage_setting": 1,
    //           "can_edit_detail": 1,
    //           "can_change_status": 1,
    //           "can_manage_channel": 1,
    //           "can_choose_pending_am": 1,
    //           "can_view_account": 1,
    //           "can_sdk_callback": 1,
    //           "can_create_aff": 1,
    //           "can_aff_export": 1,
    //           "can_change_password": 1,
    //           "can_login_user": 1,
    //           "can_view_detail": 1,
    //           "can_testing": 1,
    //           "can_manage_postback": 1,
    //           "can_recommend_manage": 1,
    //           "can_manage_source": 1
    //       },
    //       "website": {
    //           "can_edit_event": 1,
    //           "can_create_event": 1,
    //           "can_view_money_app": 1,
    //           "can_create_resource": 1,
    //           "can_create_money_app": 1,
    //           "can_edit_resource": 1,
    //           "can_edit_money_banner": 1,
    //           "can_create_money_banner": 1,
    //           "can_view_event": 1,
    //           "can_view_resource": 1,
    //           "can_delete_event": 1,
    //           "can_delete_money_app": 1,
    //           "can_delete_resource": 1,
    //           "can_view_money_banner": 1,
    //           "can_edit_money_app": 1,
    //           "can_delete_money_banner": 1
    //       },
    //       "self_service": {
    //           "can_view_message_list": 1,
    //           "can_change_adjusting_discounts": 1,
    //           "can_view_blog_list": 1,
    //           "can_view_app_list": 1,
    //           "can_change_all_sale": 1,
    //           "can_view_campaign_list": 1,
    //           "can_view_aso_advertiser_list": 1,
    //           "can_view_record_list": 1
    //       },
    //       "auth": {
    //           "can_view_role": 1,
    //           "can_view_department": 1,
    //           "can_view_employees": 1
    //       },
    //       "team_users": [
    //           85684
    //       ]
    //   }
    // }

    let response = await $http.get('/api/data/permissions/')
    commit('PERM', response.data)
    return response.data
  },

  async getRole({ commit }) {
    let response = await $http.get('/api/data/settings/', {
      params: {
        fields: 'role',
      },
    })
    commit('ROLE', response.data)
    window.localStorage.setItem('ROLE', JSON.stringify(response.data.role))
  },

  // 获取各个模块的setting列表
  async getSetting(context, { fields, stat, mutation }) {
    if (Object.keys(context.state[stat]).length === 0) {
      let response = await $http.get('/api/data/settings/', {
        params: {
          fields: fields,
        },
      })
      context.commit(mutation, response.data)
    }
  },
  // 获取国家列表
  async getCountry(context) {
    if (context.state.countries.length === 0) {
      let response = await $http.get('/api/data/countries/')
      let data = response.data
      for (let item of data) {
        item.label = item.code + '-' + item.name
      }
      // data.push({
      //   code: 'global',
      //   name: 'global',
      //   label: 'Global',
      // })
      context.commit('COUNTRIES', data)
    }
  },
  // 获取carrier列表
  async getCarrier(context) {
    if (Object.keys(context.state.carriers).length === 0) {
      let data = await $http.get('/api/data/carriers/')
      // 对所有国家下的carrier进行去重，push到result数组
      let result = []
      let hash = {}
      for (let key in data) {
        let list = data[key]
        for (let i = 0, il = list.length; i < il; i++) {
          let name = list[i].name
          if (!hash[name]) {
            result.push(list[i])
            hash[name] = 1
          }
        }
      }
      context.commit('CARRIERS', {
        carriers: data,
        all_carriers: result,
      })
    }
  },
  // 获取时区列表
  // 因为现在有两个时区列表，还不统一。这个列表暂时只用在offer模块
  async getTimezone(context) {
    if (context.state.timezone.length === 0) {
      let data = await $http.get('/api/data/timezones-v2/')
      for (let item of data.data) {
        item.label = item.gmt + ' ' + item.location
      }
      context.commit('TIMEZONE', data.data)
    }
  },

  async getTimezoneV1(context) {
    if (context.state.timezonev1.length === 0) {
      let data = await $http.get('/api/data/timezones/')
      for (let item of data.data) {
        item.label = item.gmt + ' ' + item.location
      }
      context.commit('TIMEZONEV1', data.data)
    }
  },

  async getCriticism(context) {
    if (context.state.criticism_reason.length === 0) {
      let data = await $http.get('/api/data/evaluate-reason/', {
        params: {
          fields: 'criticism',
        },
      })
      context.commit('CRITICISM_REASON', data)
    }
  },

  // 获取错误码信息
  async getCodeReason(context) {
    if (Object.keys(context.state.code_reason).length === 0) {
      let data = await $http.get('/api/data/code-reason/')
      context.commit('CODE_REASON', data)
    }
  },
}
